
import { Button, Dropdown } from "flowbite-react";
import PBLogo from "../../Assets/fuelpro-logo.png";
import { useAppDispatch, useAppSelector } from "../../Reducers/store";
import { Link } from "react-router-dom";
import { useState } from "react";
import { fetchCurrentUser } from "../../Actions";
import { HiMenu } from "react-icons/hi";
import { FaUser } from "react-icons/fa";
import { UserLevelNames } from "../../Models/UserLevel";
import DriverClockInOut from "../User/Driver/DriverClockInOut";
import { HiHome, HiUsers } from "react-icons/hi";
import { FaFlag, FaReceipt, FaUserTie, FaLock } from "react-icons/fa";
import { FaShop } from "react-icons/fa6";
import { FaClipboardList } from "react-icons/fa";
import { RiCalendarScheduleFill } from "react-icons/ri";
import { PiHandWithdrawFill, PiTruckTrailerFill } from "react-icons/pi";
import { MdAttachMoney, MdInventory, MdSettings } from "react-icons/md";

export default function TopNav() {
  const dispatch = useAppDispatch();
  const { userModel } = useAppSelector((state) => state.user);

  const logout = () => {
    localStorage.removeItem("FuelProToken");
    dispatch(fetchCurrentUser());
  };

  const [showClockInOut, setshowClockInOut] = useState<boolean>(false);
  // const [orderItemsCount, setOrderItemsCount] = useState<number>(0);





  return (
    <>
      <div className="w-full sticky top-0 z-10">
        <div className="flex bg-black px-4 justify-between">
          <Link to={"/"} className="">
            <img src={PBLogo} className="mr-3 h-12" alt="Fuel Pro" />
          </Link>
          <div className="flex my-auto">
            <div className="hidden lg:flex gap-4">
              {userModel && userModel.userLevelId !== UserLevelNames.Driver && (
                <Link to={"/order-fuel"}>
                  <Button type="button" className="buttonMain">
                    Order Fuel
                  </Button>
                </Link>
              )}
              {userModel && (
                <Button
                  type="button"
                  className="buttonMain"
                  onClick={() => setshowClockInOut(true)}
                >
                  Driver
                </Button>
              )}
            </div>
            <div className="flex lg:hidden gap-2">
              {userModel && (
                <Button
                  type="button"
                  className="buttonMain text-xs px-1 py-1"
                  onClick={() => setshowClockInOut(true)}
                >
                  Driver
                </Button>
              )}
              <div className="block">
                <Dropdown
                  label=""
                  dismissOnClick={false}
                  renderTrigger={() => (
                    <div>
                      <HiMenu size={35} className="text-white cursor-pointer" />
                    </div>
                  )}
                >
                  {userModel && userModel.userLevelId === UserLevelNames.Driver ? (
                    <>
                      <Dropdown.Item href="/" icon={HiHome}>
                        Dashboard
                      </Dropdown.Item>
                      <Dropdown.Item href="/delivery/list" icon={FaReceipt}>
                        Deliveries
                      </Dropdown.Item>
                      <Dropdown.Item href="/orders" icon={FaClipboardList}>
                        Orders
                      </Dropdown.Item>
                      <Dropdown.Item href="/assets" icon={PiTruckTrailerFill}>
                        Assets
                      </Dropdown.Item>
                      <Dropdown.Item href="/inspections" icon={FaFlag}>
                        Inspections
                      </Dropdown.Item>
                      <Dropdown.Item href={`/user/${userModel?.id}`} icon={FaUser}>
                        Profile
                      </Dropdown.Item>
                      <Dropdown.Item icon={FaLock}>
                        <button onClick={logout} className="text-red-500">
                          Logout
                        </button>
                      </Dropdown.Item>
                    </>
                  ) : (
                    <>
                      <Dropdown.Item href="/" icon={HiHome}>
                        Dashboard
                      </Dropdown.Item>
                      <Dropdown.Item href="/inventory/prices" icon={MdAttachMoney}>
                        Daily Prices
                      </Dropdown.Item>
                      <Dropdown.Item href="/clients" icon={FaUserTie}>
                        Clients
                      </Dropdown.Item>
                      <Dropdown.Item href="/jobs" icon={RiCalendarScheduleFill}>
                        Jobs
                      </Dropdown.Item>
                      <Dropdown.Item href="/delivery/list" icon={FaReceipt}>
                        Deliveries
                      </Dropdown.Item>
                      <Dropdown.Item href="/inventory/list" icon={MdInventory}>
                        Inventory
                      </Dropdown.Item>
                      <Dropdown.Item href="/orders" icon={FaClipboardList}>
                        Orders
                      </Dropdown.Item>
                      <Dropdown.Item href="/vendors" icon={FaShop}>
                        Vendors
                      </Dropdown.Item>
                      <Dropdown.Item href="/assets" icon={PiTruckTrailerFill}>
                        Assets
                      </Dropdown.Item>
                      <Dropdown.Item href="/inspections" icon={FaFlag}>
                        Inspections
                      </Dropdown.Item>
                      <Dropdown.Item
                        href="/reimbursements"
                        icon={PiHandWithdrawFill}
                      >
                        Reimbursements
                      </Dropdown.Item>
                      <Dropdown.Item href="/users" icon={HiUsers}>
                        Users
                      </Dropdown.Item>
                      <Dropdown.Item href="/admin" icon={MdSettings}>
                        Admin
                      </Dropdown.Item>
                      <Dropdown.Item href={`/user/${userModel?.id}`} icon={FaUser}>
                        Profile
                      </Dropdown.Item>
                      <Dropdown.Item icon={FaLock}>
                        {!userModel && (
                          <Link to={"/login"}>
                            <button className="text-green-600">Login</button>
                          </Link>
                        )}
                        {userModel && (
                          <button onClick={logout} className="text-red-500">
                            Logout
                          </button>
                        )}
                      </Dropdown.Item>
                    </>
                  )}
                </Dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>
      <DriverClockInOut show={showClockInOut} setShow={setshowClockInOut} />
    </>
  );
}
